import React, { useState } from "react";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import Header from "./Header";
import BaseContainerDividingLineRHSSidebar from "./BaseContainerDividingLineRHSSidebar";
import rect6518 from "../img/rectangle-6518@2x.svg"
import NextButton from "../components/NextButton";
import BackButton from "../components/BackButton";
import MultiSelectDropdwon from "../components/MultiSelectDropdown";
import IncomeBreakdownButton from "./IncomeBreakdownButton";
import logo from "../img/group-6@2x.svg";
import "./Revenue.css";


const Revenue = () => {
    const [userSalary, setUserSalary] = useState('')
    const [userCPP, setUserCPP] = useState('');
    const [userPension, setUserPension] = useState('');

    const { user } = useAuth0();

    const incomeList = [
        "Salary",
        "Canadian Pension Plan",
        "Old Age Security",
        "Employer Pension",
        "Dividends",
        "Capital Gains",
        "Passive Income",
        "Commission",
        "Royalties",
        "Rental Income",
        "Unemployment Income",
        "Trust Fund",
        "Insurance",
        "Other"
    ]

    const onSubmit = (e) => {
        e.preventDefault();
        console.log('Income: ', user.sub, userSalary, userCPP, userPension)
        axios.get(`http://localhost:4000/INCOME/add?IncomeID=${user.sub}&Salary=${userSalary}&CPP=${userCPP}&Pension=${userPension}`)
        .then(response => {
            console.log(response)
            // setSaving(false);
        })
        .catch(error => {
            console.log(error)
        })
    }

    return (
        <div className="container-center-horizontal">
            <div className="income-home-page screen">
                <div className="flex-col-23">
                    <Header />
                    <div className="overlap-group4-1">
                        <BaseContainerDividingLineRHSSidebar />
                        <div className="income-6 nunito-bold-black-30px">Income</div>
                        <img className="rectangle-6456-16" src={rect6518} />
                        <div className="rectangle-6457-6 border-1px-athens-gray-2"></div>
                        <div className="rectangle-6458-3 border-1px-athens-gray-2"></div>
                        <div className="change-plan">
                            <div className="change-plan-1 nunito-bold-black-20px">Income breakdown</div>
                        </div>
                        <div className="annual-salary nunito-semi-bold-oxford-blue-11-7px">What is your annual salary?</div>
                        <div className="monthly-cpp nunito-semi-bold-oxford-blue-11-7px">What does your CPP payout monthly?</div>
                        <div className="annual-pension nunito-semi-bold-oxford-blue-11-7px">What does your employee pension payout annualy?</div>
                        <form onSubmit={onSubmit}>
                            <input
                                className="user-salary"
                                type="number"
                                placeholder="$"
                                onChange={(e) => {
                                    setUserSalary(e.target.value);
                                }}
                            />
                            <input 
                                className="user-cpp"
                                type="number"
                                placeholder="$"
                                onChange={(e) => {
                                    setUserCPP(e.target.value);
                                }}
                            />
                            <input
                                className="user-pension"
                                type="number"
                                placeholder="$"
                                onChange={(e) => {
                                    setUserPension(e.target.value);
                                }}
                            />
                            <button type="submit" className="save-button-tfsa">Save</button>
                        </form>
                        {/* <MultiSelectDropdwon multiSelect={incomeList} className='revenue-dropdown' /> */}
                        <NextButton nextPage="/investments" />
                        <BackButton backPage="/" />
                        <IncomeBreakdownButton className="nunito-bold-azure-radiance-14px" handLogo={logo} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Revenue;